<template>
  <div class="ranger" @click="handleRangerClick" :class="enabled ? 'active' : 'inactive'">
    <div class="labels">
      <div class="low">{{ min }}</div>
      <h6 class="clickme" v-if="!enabled">Click to select a value...</h6>
      <div class="high">{{ max }}</div>
    </div>
    <div class="value" v-if="show_val_tooltip" :style="`left: ${left_pos}`">
      {{ val }}
    </div>
    <input
      v-model="val"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      :disabled="!enabled"
      @change="handleChange"
    />
  </div>
</template>

<script lang="ts">
export default {
  props: {
    min: { type: Number, required: true },
    max: { type: Number, required: true },
    step: { type: Number, default: 1 },
    edit_mode: { type: Boolean, default: false },
    value: { type: Number, default: undefined },
  },
  data() {
    return {
      enabled: !isNaN(this.value) || false,
      val: this.value,
    }
  },
  computed: {
    show_val_tooltip() {
      return this.enabled && !isNaN(this.val)
    },
    left_pos() {
      const full_range = this.max - this.min
      const progress = this.val - this.min
      if (full_range === 0) {
        return 0
      }
      const percent = (progress / full_range) * 100
      // range inputs are tricky because the thumb doesnt actually travel
      // the full range and hang off either edge. The following extra math
      // accounts for those offsets so that the value bubble stays centered
      // over the thumb. If we run into cross-browser issues, there are more
      // elaborate approaches discussed here: https://css-tricks.com/value-bubbles-for-range-inputs/
      return `calc(${percent}% + (${8 - percent * 0.15}px))`
    },
  },
  methods: {
    handleRangerClick() {
      // set it to half way between min and max - in steps.  aka
      // some multiple of steps.  this is because it likely will not
      // be half way between min and max
      if (!this.enabled) {
        const steps = (this.max - this.min) / this.step
        this.val = this.min + this.step * Math.floor(steps / 2)
      }
      this.enabled = true
    },
    handleChange() {
      this.$emit('change', this.val)
    },
  },
}
</script>
<style lang="sass" scoped>
.labels
  display: flex
  width: 100%
  justify-content: space-between
  height: 18px
  .low,.high
    font-size: .75em
.value
  background-color: var(--uePurple)
  color: white
  font-weight: bolder
  position: absolute
  transform: translateX(-50%)
  padding: .25em .25em .125em .25em
  top: calc(-.75em - 5px)
  border-radius: 2px
  box-shadow: 2px 2px 4px #aaa
  cursor: default
.value::after
  content: ''
  width: 0
  height: 0
  border-left: 6px solid transparent
  border-right: 6px solid transparent
  border-top: 5px solid var(--uePurple)
  position: absolute
  top: 100%
  left: 50%
  transform: translateX(-50%)

input[type='range']:focus
  border: none!important
  box-shadow: none!important
input[type='range']
  padding: 0
  min-height: 1em
  accent-color: var(--uePurple)
  width: 100%
  cursor: pointer

.ranger
  margin-top: 32px
  position: relative
  // pointer-events: all
  background-color: transparent

  h6.clickme
    margin: 0
    color: hsl(200, 12%, 44%)
    font-size: 10px
    font-weight: 200
    text-transform: uppercase
    letter-spacing: 2px

// This allows the click event to pass throught the higher stack order
// elements (and activate the component). Without this, the higher elements
// would block the click and we would need to add the listener to every
// element.
.inactive.ranger *
  pointer-events: none
.inactive.ranger
  cursor: pointer
</style>
